const host = process.env.REACT_APP_ROOT;
const local_agam = "http://127.0.0.1:3232/api";
const live_agam = "http://139.162.47.231:3232/api";
const admin_domain = process.env.REACT_APP_ROOT_DOMAIN;
export const route = {
  root: {
    socketio: process.env.REACT_APP_SOCKETIO || "http://172.16.16.172:4001",
    branch: host + "/branch",
    barangay: host + "/barangay",
    newsadvisory: host + "/news-advisory",
    powerinterruption: host + "/power-interruption",
    // agam: host + "/agam/pool",
    // New API
    agam: host + "/agam/pool",
    profile: host + "/about-us/profile",
    mission: host + "/about-us/mission",
    vision: host + "/about-us/vision",
    coreValues: host + "/about-us/core",
    rates: host + "/rates",
    announcements: host + "/announcements",
    careers: host + "/careers",
    css: host + "/customer-satisfaction-survey",
  },
  domain: admin_domain,
};
